"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebBDataLoader = exports.AndroidBDataLoader = exports.IosBDataLoader = exports.BDataLoader = void 0;
const scriptLibraryLoader_1 = require("../../../../core/library/loader/scriptLibraryLoader");
const constants_1 = require("./constants");
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class BDataLoader extends scriptLibraryLoader_1.ScriptLibraryLoader {
    constructor(urls) {
        super('BData', constants_1.LOAD_CONFIG);
        this.urls = urls;
    }
    getUrls() {
        return this.urls;
    }
}
exports.BDataLoader = BDataLoader;
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class IosBDataLoader extends BDataLoader {
    constructor(baseUrl, slaveUrl) {
        super([baseUrl, slaveUrl]);
    }
}
exports.IosBDataLoader = IosBDataLoader;
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class AndroidBDataLoader extends BDataLoader {
    constructor(url) {
        super([url]);
    }
}
exports.AndroidBDataLoader = AndroidBDataLoader;
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class WebBDataLoader extends BDataLoader {
    constructor(url) {
        super([url]);
    }
}
exports.WebBDataLoader = WebBDataLoader;
//# sourceMappingURL=index.js.map